var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "flex grid", style: _vm.contentStyle }, [
      _c("div", { staticClass: "grid grid-flow-col gap-1" }, [
        _c(
          "span",
          {
            staticClass: "font-small block notification-title",
            class: ["text-" + _vm.item.dropdownCategory],
          },
          [
            _c("feather-icon", {
              class: [
                "text-" + _vm.item.dropdownCategory,
                "stroke-current h-5 w-5",
              ],
              attrs: { icon: _vm.formatIconName(_vm.item) },
            }),
            _vm._v(" " + _vm._s(_vm.item.dropdownTitle) + " "),
          ],
          1
        ),
        _c("small", { staticClass: "pl-2 text-right whitespace-no-wrap" }, [
          _vm._v(_vm._s(_vm.elapsedTime(_vm.item.sentAt))),
        ]),
      ]),
      _c("div", { staticClass: "item-data-container" }, [
        _c("small", { staticClass: "break-all" }, [
          _c("div", {
            directives: [
              {
                name: "html-safe",
                rawName: "v-html-safe",
                value: _vm.item.message(300),
                expression: "item.message(300)",
              },
            ],
          }),
        ]),
      ]),
      _c("div", {
        style: _vm.faderElementStyle,
        attrs: { hidden: !_vm.collapseContent },
      }),
    ]),
    _c(
      "div",
      {
        staticClass: "hover:text-primary cursor-pointer mt-1 w-full",
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.expandCard.apply(null, arguments)
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "flex justify-center" },
          [
            _c("feather-icon", {
              staticClass: "mr-1",
              attrs: {
                svgClasses: "w-7 h-7",
                icon: _vm.collapseContent ? "ChevronDownIcon" : "ChevronUpIcon",
              },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }